module.exports = __webpack_public_path__ + "static/media/hs_14.b4983ccd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/heads/JPEG/hs_14.jpg
// module id = 5945
// module chunks = 0